import { Component, OnInit, Input } from '@angular/core';
import { ReqService } from '@core/services';
import { dialogConfig } from '@modals/dialog.configure';
import { ModalImageMessageComponent } from '@modals/image-message/image-message.component';
import { MbDialog, MbAlertModule } from '@am/moebius';
import { NgIf } from '@angular/common';

@Component({
    selector: 'image-message',
    templateUrl: './image-message.component.html',
    styleUrls: ['./image-message.component.scss'],
    standalone: true,
    imports: [NgIf, MbAlertModule],
})
export class ImageMessageComponent implements OnInit {
  @Input()
  hotelCountry: any;

  public showMessage: boolean;

  constructor(
    private reqService: ReqService,
    private dialog: MbDialog,
  ) {}

  ngOnInit() {
    const colombiaId = 1124767;
    this.showMessage =
      this.reqService.getCountry() === 'col' && this.hotelCountry === colombiaId;
  }

  public openModal() {
    if (!this.dialog.isAnyDialogOpen) {
      this.dialog.open(ModalImageMessageComponent, {
        ...dialogConfig,
        closeBtn: true,
      });
    }
  }
}
